import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Problem from '../components/Problem';
import Services from '../components/Services';
import Projects from '../components/Projects';
import About from '../components/About';
import Faq from '../components/Faq';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';
import { PROJECTS_PATH } from '../routes';
import './LandingPage.css';

function LandingPage() {
  useSeo();

  return (
    <div className="landing-page">
      <Navigation />
      <Hero />
      <Projects group="production" />
      <Problem />
      <Services />
      <About />
      <Faq />
      {/* A shortlist only — the full, filterable catalogue lives on its own page. */}
      <Projects group="demo" facets={[]} featured moreLink={PROJECTS_PATH} />
      <Contact />
      <Footer />
    </div>
  );
}

export default LandingPage;
